import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ProjectForm, type ProjectFormInitial } from "@/components/admin/ProjectForm";
import { adminProjectQuery } from "@/lib/query-registry";

export const Route = createFileRoute("/admin/projects/$id")({
  component: EditProject,
});

function EditProject() {
  const { id } = Route.useParams();
  const query = useQuery(adminProjectQuery(id));

  return (
    <div>
      <Link to="/admin/projects" className="text-sm text-muted-foreground hover:text-foreground">
        ← Back to projects
      </Link>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-foreground">
        Edit project
      </h1>
      <div className="mt-8">
        {query.isPending && <p className="text-sm text-muted-foreground">Loading…</p>}
        {query.isError && (
          <div className="flex items-center gap-3">
            <p className="text-sm text-destructive">{query.error.message}</p>
            <button
              type="button"
              onClick={() => query.refetch()}
              className="rounded-full border border-border px-4 py-1.5 text-xs font-medium text-foreground hover:bg-card"
            >
              Retry
            </button>
          </div>
        )}
        {query.isSuccess && query.data?.project && (
          // Supabase's generated row type is looser than the form's (e.g.
          // `metrics` is generic Json, `engagement_type` is a plain string)
          // because Postgres doesn't encode those constraints in codegen.
          // The row is always well-formed at this boundary in practice.
          <ProjectForm initial={query.data.project as unknown as ProjectFormInitial} />
        )}
        {query.isSuccess && !query.data?.project && (
          <p className="text-sm text-muted-foreground">Project not found.</p>
        )}
      </div>
    </div>
  );
}
